import React from 'react';

import { useProducts } from '../../../hooks/useProducts';
import ProductTile from '../../ProductTile';

type Props = {
  productIds: Array<string>;
  heading?: string | null;
  carouselPerPage?: 3 | 4;
  analytics?: Analytics & { carouselTitle?: string };
};

const ProductsByIdCarousel: React.FC<Props> = ({
  analytics,
  heading,
  productIds,
}) => {
  const { products } = useProducts(productIds);
  const productTileComponents = products.map((product, idx) => (
    <ProductTile
      key={product.id}
      analytics={
        analytics && {
          page: analytics.page,
          context: analytics.context,
          position: idx,
        }
      }
      product={product}
    />
  ));

  if (!products || !products?.length) return null;

  return (
    <div>
      {heading ? (
        <div className="mb-4 flex w-full justify-between gap-x-3">
          <h2 className="neutral-4 relative z-20 text-md md:text-lg">
            {heading}
          </h2>
        </div>
      ) : null}

      <div className="grid-section gap-y-6">
        {productTileComponents.map((item, index) => (
          <div
            key={index}
            className="col-span-6 flex flex-col gap-y-3 md:col-span-4 lg:col-span-3"
          >
            {item}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductsByIdCarousel;
